



import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'RequiredBadge'
})
export default class RequiredBadge extends Vue {

}
